import { render, staticRenderFns } from "./NewLinkedinChannel.vue?vue&type=template&id=632f0d3c&scoped=true"
import script from "./NewLinkedinChannel.vue?vue&type=script&lang=js"
export * from "./NewLinkedinChannel.vue?vue&type=script&lang=js"
import style0 from "./NewLinkedinChannel.vue?vue&type=style&index=0&id=632f0d3c&prod&lang=scss&scoped=true"
import style1 from "./NewLinkedinChannel.vue?vue&type=style&index=1&id=632f0d3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632f0d3c",
  null
  
)

export default component.exports